import React from 'react';
import { OrderBookRowFieldProps } from '../../../types';

export const OrderBookSideCount = (props: OrderBookRowFieldProps) => {
  return <span>{props.metric.cnt}</span>;
};

export default OrderBookSideCount;
